"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GrantKscUserRightsRequest = void 0;
var GrantKscUserRightsRequest;
(function (GrantKscUserRightsRequest) {
    let Role;
    (function (Role) {
        Role["NONE"] = "None";
        Role["WORKSPACE_USER"] = "WorkspaceUser";
        Role["WORKSPACE_ADMINISTRATOR"] = "WorkspaceAdministrator";
    })(Role = GrantKscUserRightsRequest.Role || (GrantKscUserRightsRequest.Role = {}));
})(GrantKscUserRightsRequest || (exports.GrantKscUserRightsRequest = GrantKscUserRightsRequest = {}));
